import {Global, css} from '@emotion/react';
import type {LanguageId} from '../translations/utils/languageManifest';
import type {WrapRootElementBrowserArgs, WrapRootElementNodeArgs} from 'gatsby';
import type {ReactNode} from 'react';

const globalStyles = css`
  :root {
    color-scheme: light;
  }

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  body {
    margin: 0;
    font-family:
      'Inter',
      'Segoe UI',
      -apple-system,
      BlinkMacSystemFont,
      sans-serif;
  }
`;

const EmotionWrapper = ({children}: {children: ReactNode}) => (
  <>
    <Global styles={globalStyles} />
    {children}
  </>
);

type WrapperProvider<TPageProps extends Record<string, unknown>> = React.ComponentType<{
  readonly locale: LanguageId;
  readonly children: ReactNode;
  readonly pageProps: TPageProps;
}>;

export const createMicrositeGatsbyWrapper = <TPageProps extends Record<string, unknown>>(Provider: WrapperProvider<TPageProps>, defaultLocale: LanguageId, defaultPageProps: TPageProps) => {
  return ({element}: WrapRootElementBrowserArgs | WrapRootElementNodeArgs) => (
    <EmotionWrapper>
      <Provider locale={defaultLocale} pageProps={defaultPageProps}>
        {element}
      </Provider>
    </EmotionWrapper>
  );
};
